import React from "react";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  changeActiveTab,
  getDraftSkillsById,
  cloneDraftSkill,
  checkAndOnboardAgent,
} from "../../../../../redux/actions/skill";
import { notify } from "../../../../../redux/actions/snack";
import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
  Modifier,
  SelectionState,
} from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import htmlToDraft from "html-to-draftjs";

const CloneSkillModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userId = useSelector((state) => state.userReducer?.user?.sub);

  const [skillName, setSkillName] = useState("");
  const [skillDesc, setSkillDesc] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const currentTeam = useSelector(
    (state) => state.organizationReducer?.currentOrganization?.id
  );
  const toolbarOptions = {
    options: ["inline", "blockType", "fontFamily", "list", "history"],
    inline: {
      options: ["bold", "italic", "underline"],
    },
    blockType: {
      options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6"],
    },
    fontFamily: {
      options: [
        "Arial",
        "Calibri",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
    },
    list: {
      options: ["unordered", "ordered"],
    },
    history: {
      options: ["undo", "redo"],
    },
  };
  const editorRef = useRef(null);

  const userRole = useSelector(
    (state) => state.organizationReducer.currentOrgUser
  );
  const draftSkill = useSelector((state) => state.skillReducer?.helper);

  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    let text = tempDiv.textContent || tempDiv.innerText || "";
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  useEffect(() => {
    setSkillName("Copy of " + draftSkill?.SKILL_NAME);
    const sanitizedDescription = removeHtmlTags(draftSkill?.SKILL_DESCRIPTION);
    setSkillDesc(sanitizedDescription);

    const contentBlocks = htmlToDraft(sanitizedDescription);
    const contentState = ContentState.createFromBlockArray(contentBlocks);

    const hasUnderline = sanitizedDescription.includes("<u>");

    if (hasUnderline) {
      const selection = new SelectionState({
        anchorKey: contentState.getFirstBlock().getKey(),
        anchorOffset: 0,
        focusKey: contentState.getLastBlock().getKey(),
        focusOffset: contentState.getLastBlock().getText().length,
      });
      const contentStateWithUnderline = Modifier.applyInlineStyle(
        contentState,
        selection,
        "UNDERLINE"
      );
      setEditorState(EditorState.createWithContent(contentStateWithUnderline));
    } else {
      setEditorState(EditorState.createWithContent(contentState));
    }

    return () => {
      setSkillName("");
      setEditorState(EditorState.createEmpty());
    };
  }, [draftSkill?.id]);

  const handleChange = (e) => {
    setSkillName(e.target.value);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    let createSkill;
    const currentContent = editorState.getCurrentContent();
    const rawContentState = convertToRaw(currentContent);
    const skillDescText = rawContentState.blocks[0].text.trim();
    if (skillName.trim() === "") {
      dispatch(notify("error", "Skill name cannot be empty"));
      setIsLoading(false);

      return;
    }

    if (skillDescText.trim() === "") {
      dispatch(notify("error", "Skill description cannot be empty"));
      setIsLoading(false);

      return;
    }
    if (draftSkill?.TEMPLATE === "GenAi Automation") {
      let payload = {
        v2SkillId: draftSkill?.v2SkillId,
        v2AgentId: draftSkill?.v2AgentId,
        name: skillName,
        description: skillDescText,
      };
      let res = await dispatch(checkAndOnboardAgent(payload));
      console.log(res, "rrererr");
      let skill = {
        SKILL_NAME: skillName,
        SKILL_DESCRIPTION: skillDesc,
        TEMPLATE: draftSkill?.TEMPLATE,
        USER_ID: userId,
        TYPE: "regularSkill",
        organizationId: currentTeam || null,
        status: "self",
        USER_EMAIL: userRole?.email,
        RAW_DATA: draftSkill?.RAW_DATA,
        FORMATED_DATA: draftSkill?.FORMATED_DATA,
        v2SkillId: res?.data?.automationId,
        v2AgentId: res?.data?.agentId,
      };

      createSkill = await dispatch(cloneDraftSkill(skill));
      console.log(createSkill, "createSkill");
      if (createSkill?.data?.status) {
        setIsLoading(false);
  
        dispatch(notify("success", "Agent cloned successfully"));
        history.push(`/dashboard/skills/createAutomationV2/${encodeURIComponent(skillName)}&${res?.data?.agentId}&${res?.data?.automationId}?draftId=${createSkill.data?.data?.id}&orgId${draftSkill?.organizationId}`
);
        dispatch(changeActiveTab("Draft"));
        $(".modal-backdrop").hide();
      } else {
        if (createSkill?.data?.response === "failed") {
          setIsLoading(false);
  
          dispatch(notify("error", `${createSkill?.data?.error}`));
        } else {
          setIsLoading(false);
  
          dispatch(
            notify(
              "error",
              "Skill name is already taken. Please choose another name"
            )
          );
        }
      }
      
    } else {
      const trainSkill = await dispatch(getDraftSkillsById(draftSkill?.id));
      let skill = {
        SKILL_NAME: skillName,
        SKILL_DESCRIPTION: skillDesc,
        TEMPLATE: trainSkill?.data?.data?.TEMPLATE,
        USER_ID: userId,
        TYPE: "regularSkill",
        organizationId: currentTeam || null,
        status: "self",
        USER_EMAIL: userRole?.email,
        RAW_DATA: trainSkill?.data?.data?.RAW_DATA,
        FORMATED_DATA: trainSkill?.data?.data?.FORMATED_DATA,
        v2SkillId: trainSkill?.data?.data?.v2SkillId,
        v2AgentId: trainSkill?.data?.data?.v2AgentId,
      };
      createSkill = await dispatch(cloneDraftSkill(skill));
      if (createSkill?.data?.status) {
        setIsLoading(false);
  
        dispatch(notify("success", "Agent cloned successfully"));
        history.push(`/dashboard/skills/viewSkill/${createSkill.data?.data?.id}`);
        dispatch(changeActiveTab("Draft"));
        $(".modal-backdrop").hide();
      } else {
        if (createSkill?.data?.response === "failed") {
          setIsLoading(false);
  
          dispatch(notify("error", `${createSkill?.data?.error}`));
        } else {
          setIsLoading(false);
  
          dispatch(
            notify(
              "error",
              "Skill name is already taken. Please choose another name"
            )
          );
        }
      }
    }

  
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap();
    const fontFamilies = [
      "Arial",
      "Calibri",
      "Georgia",
      "Impact",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ];
    let fontFamiliesString = "";
    let htmlWithStyles = stateToHTML(contentState);

    blocks.forEach((block) => {
      const inlineStyles = block.getInlineStyleAt(0);
      const fontFamilyStyle = inlineStyles.find(
        (style) =>
          style.startsWith("fontfamily-") || fontFamilies.includes(style)
      );

      if (fontFamilyStyle) {
        const fontFamily = fontFamilyStyle.replace("fontfamily-", "");
        if (fontFamilies.includes(fontFamily)) {
          fontFamiliesString = fontFamily;
          htmlWithStyles = `<span style="font-family: ${fontFamily}">${htmlWithStyles}</span>`;
        }
      }
    });

    setSkillDesc(htmlWithStyles);
  };

  return (
    <div
      id="cloneSkillModal"
      className="modal fade crt-skill"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog">
        <div className="modal-content crt-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <h4 className="modal-title">Clone Agent</h4>
          </div>
          <div className="modal-body">
            <div className="form-contain">
              <div className="steps-block">
                <div className="ip-tl-label">
                  <span className="tl-label">Skill Name</span>

                  <input
                    type="text"
                    name="skillName"
                    placeholder="Enter Skill Name"
                    defaultValue={skillName}
                    onChange={(e) => handleChange(e)}
                  ></input>
                </div>
                <div className="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">Description</span>
                    <div className="RichEditor-root">
                      <Editor
                        name="skillDesc"
                        ref={editorRef}
                        spellCheck={false}
                        toolbarOnFocus={false}
                        editorState={editorState}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        placeholder="Enter Description"
                        onEditorStateChange={onEditorStateChange}
                        toolbar={toolbarOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="frm-btns">
                <button className="btn-outline" data-dismiss="modal">
                  Cancel
                </button>

                {isLoading ? (
                  <button className="btn btn-primary">
                    <div class="sp sp-circle text-light"></div>
                  </button>
                ) : (
                  <button
                    className="btn-primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneSkillModal;
